// src/components/core/MigrationModal/tabs/ConnectionTab.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Space, Typography, Switch, Tooltip, Row, Col, Input, Button, theme } from 'antd';
import { ApiOutlined, KeyOutlined, DeleteOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ConnectionTab = ({
  tokenData,
  connectionEnabled,
  locked,
  onOpenTokenModal,
  onToggleConnection,
  onDeleteToken,
}) => {
  const { token: antToken } = theme.useToken();

  // ─────────────────────────────────────────────────────────────────────────────
  // UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div style={{ paddingTop: 8 }}>
      <Card
        size="small"
        title={
          <Space>
            <ApiOutlined style={{ color: antToken.colorPrimary }} />
            <span className="text-muted">{translateX('connection')}</span>
          </Space>
        }
        extra={
          <Space>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {connectionEnabled
                ? translateX('connection_active')
                : translateX('connection_inactive')}
            </Text>
            <Tooltip
              title={
                !tokenData
                  ? translateX('configure_token_first')
                  : connectionEnabled
                    ? translateX('deactivate_connection')
                    : translateX('activate_connection')
              }
            >
              <Switch
                size="small"
                checked={connectionEnabled}
                onChange={onToggleConnection}
                disabled={locked || !tokenData}
              />
            </Tooltip>
          </Space>
        }
      >
        <Row gutter={[16, 16]} className="mt-3">
          {/* Token Field */}
          <Col xs={24} sm={14}>
            <div style={{ marginBottom: 4 }}>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {translateX('token')}
              </Text>
            </div>
            <Space.Compact style={{ width: '100%' }}>
              <Input
                value={tokenData?.tokenMasked || ''}
                placeholder={translateX('enter_integration_token')}
                readOnly
                disabled={locked}
              />
              <Tooltip
                title={tokenData ? translateX('remove_token') : translateX('configure_token')}
              >
                <Button
                  type="primary"
                  danger={!!tokenData}
                  icon={tokenData ? <DeleteOutlined /> : <KeyOutlined />}
                  onClick={tokenData ? onDeleteToken : onOpenTokenModal}
                  disabled={locked}
                />
              </Tooltip>
            </Space.Compact>
          </Col>

          {/* Connection Scope Field */}
          <Col xs={24} sm={10}>
            <div style={{ marginBottom: 4 }}>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {translateX('scope')}
              </Text>
            </div>
            <Input
              value={tokenData?.sourceInfo?.clientName || tokenData?.scope || ''}
              // placeholder={tokenData ? '' : translateX('not_configured')}
              readOnly
              style={{
                backgroundColor: antToken.colorBgContainerDisabled,
                color:
                  tokenData?.sourceInfo?.clientName || tokenData?.scope
                    ? antToken.colorText
                    : antToken.colorTextDisabled,
              }}
            />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ConnectionTab;
